import '../base-react';
import * as React from "react";
import { createRoot } from 'react-dom/client';
import { ReactAppMain } from '../base-react';
import { App } from "./components/App";
new class Main extends ReactAppMain {
    onCreated() {
        const container = document.getElementById('content_wrap');
        const root = createRoot(container);
        root.render(React.createElement(App, null));
    }
    getLocales() {
        return {
            en: {
                manager: require('./locales/en/home.json')
            },
            sv: {
                manager: require('./locales/sv/home.json')
            }
        };
    }
}().initialize();
